export default __webpack_public_path__ + "static/media/Download_AF4448.95b9fda8.svg";